function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import FileUpload from "./file-upload.vue";
import TableForm from "./table-form.vue";
import FileUploader from "@/components/FileUploader/index.vue";
import SingleImageUploader from "@/components/SingleImageUploader/index.vue";
import PreviewItem from "@/views/repository/components/previewItem.vue";
import TagIds from "./tag-ids.vue";
import Remove from "./remove.vue";
import NineGrid from "./nine-grid.vue";
import _cloneDeep from "lodash/cloneDeep";
import { cookRequestParams } from "@/common/request";
import { repositoryName, cat1OptionsParticle } from "@/views/repository/config";
import { animationType, animationTag } from "@ps/utils/config";
import { validate } from "@ps/workbench/resource-manager/uploader/dragon-bone";
var defaultDialogConfig = {
    title: "",
    visible: false,
    loading: false,
    disabled: false
};
var PatchDialog = /*#__PURE__*/ function(Vue1) {
    "use strict";
    _inherits(PatchDialog, Vue1);
    var _super = _createSuper(PatchDialog);
    function PatchDialog() {
        _classCallCheck(this, PatchDialog);
        var _this;
        _this = _super.apply(this, arguments);
        _this.isPatch = true;
        _this.fileUploadModel = {
            cat1_id: 1,
            file_path: []
        };
        _this.tableFormModel = [];
        _this.tableFormSchema = [];
        _this.fileList = [];
        _this.fileUploadFileList = [];
        _this.cacheModel = {
            tableFormModel: [],
            tableFormSchema: [],
            fileList: []
        };
        _this.xlzCacheModel = {
            1: {
                tableFormModel: [],
                tableFormSchema: [],
                fileList: []
            },
            2: {
                tableFormModel: [],
                tableFormSchema: [],
                fileList: []
            },
            3: {
                tableFormModel: [],
                tableFormSchema: [],
                fileList: []
            }
        };
        return _this;
    }
    var _proto = PatchDialog.prototype;
    _proto.onDialogConfigVisibleChange = function onDialogConfigVisibleChange(value) {
        if (value) {
            this.tableFormModel = [];
            this.fileList = [];
            this.tableFormSchema = [];
        }
    };
    // methods
    _proto.setErrorMessage = function setErrorMessage(param) {
        var index = param.index, errorMessage = param.errorMessage;
        var data = this.tableFormModel[index];
        data && (data.errorMessage = errorMessage);
    };
    _proto.getTableFormSchema = function getTableFormSchema(param1) {
        var isUnitypackage = param1.isUnitypackage;
        var _this = this;
        var propertiesPool = {
            name: {
                type: "string",
                component: "input",
                field: {
                    placeholder: "\u8BF7\u8F93\u5165\u540D\u79F0"
                },
                rules: [
                    {
                        required: true,
                        message: "\u8BF7\u8F93\u5165" + this.libName + "\u540D\u79F0",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 100,
                        message: this.libName + "\u540D\u79F0\u4E0D\u80FD\u8D85\u8FC7 100 \u4E2A\u5B57\u7B26",
                        trigger: "blur"
                    }
                ]
            },
            name_en: {
                type: "string",
                component: "input",
                field: {
                    placeholder: "\u8BF7\u8F93\u5165\u82F1\u6587\u540D\u79F0"
                },
                rules: [
                    {
                        required: true,
                        message: "\u8BF7\u8F93\u5165" + this.libName + "\u540D\u79F0",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 100,
                        message: this.libName + "\u82F1\u6587\u540D\u79F0\u4E0D\u80FD\u8D85\u8FC7 100 \u4E2A\u5B57\u7B26",
                        trigger: "blur"
                    }
                ]
            },
            animationCat: {
                component: "cascader",
                field: {
                    options: this.animationCat,
                    placeholder: "\u8BF7\u8F93\u5165".concat(this.libName, "\u5206\u7C7B")
                },
                rules: [
                    {
                        required: true,
                        message: "\u8BF7\u8F93\u5165".concat(this.libName, "\u540D\u79F0"),
                        trigger: "blur"
                    }
                ]
            },
            animationCover: {
                component: SingleImageUploader,
                field: {
                    placeholder: "\u8BF7\u4E0A\u4F20".concat(this.libName, "\u5C01\u9762"),
                    acceptType: [
                        "jpg",
                        "png",
                        "jpeg",
                        "gif"
                    ],
                    tip: "\u4EC5\u652F\u6301jpg, png, jpeg, gif\u683C\u5F0F\u56FE\u7247"
                },
                rules: [
                    {
                        required: true,
                        message: "\u8BF7\u8F93\u5165".concat(this.libName, "\u5C01\u9762"),
                        trigger: "blur"
                    }
                ]
            },
            resFile: {
                visible: this.resourceType !== 18,
                component: PreviewItem,
                resourceType: this.resourceType,
                isBatchAdd: true,
                field: {
                    resourceType: this.resourceType
                }
            },
            tagIds: {
                component: TagIds,
                resourceType: this.resourceType,
                rules: [
                    {
                        required: true,
                        message: "\u8BF7\u9009\u62E9\u6807\u7B7E",
                        trigger: "change"
                    }
                ],
                field: {
                    resourceType: this.resourceType,
                    listeners: {
                        change: function(value, index) {
                            _this.tableFormModel[index].tagIds = value;
                            _this.$refs.tabelForm.validateField("tagIds", index);
                            if (_this.tableFormModel[index].applyAll) {
                                _this.tableFormModel[index].applyAll = false;
                            }
                        },
                        applyAllChange: function(data) {
                            var value = data.value, tagIds = data.tagIds, index = data.index;
                            if (value) {
                                _this.cacheModel.tableFormModel = _cloneDeep(_this.tableFormModel);
                                _this.tableFormModel.forEach(function(item, idx) {
                                    if (idx !== index) {
                                        item.tagIds = _toConsumableArray(tagIds);
                                        item.applyAll = false;
                                    }
                                });
                            } else {
                                if (_this.cacheModel.tableFormModel.length === _this.tableFormModel.length) {
                                    var _this1 = _this;
                                    _this.tableFormModel.forEach(function(item, idx) {
                                        var cachedData = _this1.cacheModel.tableFormModel[idx];
                                        item.tagIds = _toConsumableArray(cachedData.tagIds);
                                        item.applyAll = cachedData.applyAll;
                                    });
                                }
                                _this.cacheModel.tableFormModel = [];
                            }
                            _this.tableFormModel[index].applyAll = value;
                        }
                    }
                }
            },
            nine: {
                component: NineGrid,
                field: {
                    listeners: {
                        change: function(param) {
                            var value = param.value, index = param.index, $index = param.$index;
                            _this.$set(_this.tableFormModel[$index].nine, index, Number(value));
                        }
                    }
                }
            },
            accessAllowPt: {
                component: "switch",
                field: {
                    disabled: isUnitypackage,
                    activeValue: 1,
                    inactiveValue: 2
                }
            },
            $action: {
                component: Remove,
                field: {
                    listeners: {
                        click: function(index) {
                            _this.tableFormModel.forEach(function(item, idx) {
                                if (idx > index) {
                                    item.$index = item.$index - 1;
                                }
                            });
                            _this.tableFormModel.splice(index, 1);
                            _this.fileList.splice(index, 1);
                            _this.tableFormSchema.splice(index, 1);
                            if (_this.accessProps.includes("tagIds")) {
                                _this.cacheModel.tableFormModel.splice(index, 1);
                            }
                        // this.fileUploadFileList.splice(index, 1)
                        }
                    }
                }
            }
        };
        var properties = this.accessProps.reduce(function(memo, cur) {
            if (propertiesPool[cur]) {
                memo[cur] = propertiesPool[cur];
            }
            return memo;
        }, {});
        return {
            type: "object",
            properties: properties
        };
    };
    _proto.getColSpan = function getColSpan(props) {
        var ret = {};
        var defaultSpan = {
            name: 3,
            name_en: 3,
            resFile: 3,
            tagIds: 9,
            accessAllowPt: 4,
            $action: 2
        };
        var span1 = {
            name: 4,
            name_en: 4,
            resFile: 4,
            // tagIds: 8,
            accessAllowPt: 7,
            $action: 4
        };
        var span11 = {
            name: 4,
            name_en: 4,
            resFile: 9,
            // tagIds: 8,
            // accessAllowPt: 6,
            $action: 4
        };
        var span2 = {
            name: 2,
            name_en: 2,
            resFile: 3,
            tagIds: 7,
            accessAllowPt: 4,
            nine: 4,
            $action: 2
        };
        var span22 = {
            name: 2,
            name_en: 2,
            resFile: 5,
            tagIds: 8,
            // accessAllowPt: 4,
            nine: 5,
            $action: 2
        };
        var span3 = {
            name: 4,
            name_en: 4,
            resFile: 3,
            tagIds: 9,
            $action: 4
        };
        var span4 = {
            name: 2,
            name_en: 2,
            resFile: 6,
            tagIds: 8,
            accessAllowPt: 4,
            $action: 2
        };
        var span44 = {
            name: 3,
            name_en: 3,
            resFile: 6,
            tagIds: 8,
            $action: 4
        };
        var span5 = {
            name: 3,
            name_en: 3,
            resFile: 6,
            tagIds: 8,
            $action: 4
        };
        if (this.isVideoManager) {
            if (this.resourceType === 13) {
                ret = span3;
            } else {
                ret = span5;
            }
            return ret[props];
        }
        if (this.isCreative) {
            switch(this.resourceType){
                case 16:
                    ret = span11;
                    break;
                case 14:
                    ret = span22;
                    break;
                case 6:
                case 15:
                    ret = span44;
                    break;
                default:
                    ret = span3;
                    break;
            }
            return ret[props];
        }
        switch(this.resourceType){
            case 16:
                ret = span1;
                break;
            case 18:
                ret = {
                    name: 3,
                    name_en: 3,
                    animationCat: 6,
                    animationCover: 6,
                    accessAllowPt: 4,
                    resFile: 0,
                    $action: 2
                };
                break;
            case 14:
                ret = span2;
                break;
            case 6:
            case 15:
                ret = span4;
                break;
            default:
                ret = defaultSpan;
                break;
        }
        return ret[props];
    };
    _proto.handleBeforeUpload = function handleBeforeUpload(file) {
        // 龙骨文件进行校验
        if (this.fileUploadModel.cat1_id === 1 && Number(this.resourceType) === 10) {
            var _this = this;
            return new Promise(function(resolve, reject) {
                var _this2 = _this;
                validate({
                    raw: file
                }).then(function(validRet) {
                    var valid = validRet.valid, message = validRet.message;
                    if (valid) {
                        resolve(true);
                    } else {
                        _this2.$message.info("".concat(file.name, " ").concat(message));
                        reject(false);
                    }
                }).catch(function() {
                    _this2.$message.info("\u6587\u4EF6\u89E3\u538B\u9519\u8BEF\uFF0C\u8BF7\u91CD\u8BD5");
                    reject(false);
                });
            });
        }
        return true;
    };
    _proto.handleUploadSuccess = function handleUploadSuccess(response, file, fileList) {
        var _this = this;
        if (response.code !== 0) {
            this.$message({
                type: "error",
                message: response.msg
            });
            return;
        }
        var data = response.data;
        var url = data.url, origin_name = data.origin_name, file_path = data.file_path;
        if (this.uniqFile(url)) return;
        this.fileList.push({
            file: data,
            filePath: url,
            name: origin_name.replace(/(\.[^.]+)?$/g, "")
        });
        var defaultFormModel = {
            name: origin_name.replace(/(\.[^.]+)?$/g, ""),
            name_en: origin_name.replace(/(\.[^.]+)?$/g, ""),
            resFile: url,
            filePath: file_path,
            tagIds: [],
            nine: [
                0,
                0,
                0,
                0
            ],
            applyAll: false,
            animationCat: "",
            animationCover: "",
            accessAllowPt: /\.unitypackage$/.test(origin_name) ? 2 : 1,
            $action: "\u79FB\u9664"
        };
        if (this.applyAllIndex > -1) {
            defaultFormModel.tagIds = _toConsumableArray(this.tableFormModel[this.applyAllIndex].tagIds);
        }
        var item = this.accessProps.reduce(function(memo, cur) {
            memo[cur] = defaultFormModel[cur];
            memo.$index = _this.fileList.length - 1;
            if (cur === "tagIds") {
                memo.applyAll = defaultFormModel.applyAll;
            }
            return memo;
        }, {});
        item.errorMessage = "";
        this.tableFormModel.push(item);
        if (this.accessProps.includes("tagIds")) {
            this.cacheModel.tableFormModel.push(_objectSpreadProps(_objectSpread({}, item), {
                tagIds: [],
                applyAll: false
            }));
        }
        this.tableFormSchema.push(this.getTableFormSchema({
            isUnitypackage: /\.unitypackage$/.test(origin_name)
        }));
    };
    _proto.uniqFile = function uniqFile(filePath) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.fileList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var file = _step.value;
                if (file.filePath === filePath) {
                    return true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return false;
    };
    _proto.handleClose = function handleClose(done) {
        if (this.dialogConfig.loading) {
            return false;
        }
        return done();
    };
    _proto.onDialogCancel = function onDialogCancel() {
        this.$emit("update:visible", false);
    };
    _proto.onDialogSubmit = function onDialogSubmit() {
        var _this = this;
        if (this.fileList.length === 0) {
            return this.$message({
                type: "info",
                message: "\u8BF7\u9009\u62E9\u6587\u4EF6"
            });
        }
        this.$refs.tabelForm.validate().then(function() {
            var _this3 = _this;
            var res_type = _this.resourceType;
            var requestField = {
                name: "name",
                name_en: "name_en",
                res_file: "resFile",
                tag_ids: "tagIds",
                ext_config: "extConfig",
                access_allow_pt: "accessAllowPt"
            };
            var params = _this.tableFormModel.map(function(item) {
                // const param:any = { res_type, file_type: 'local' }
                var param = {
                    res_type: res_type
                };
                if (_this3.resourceType === 14) {
                    param.ext_config = JSON.stringify({
                        nine: item.nine
                    });
                }
                // 特效
                if (_this3.resourceType === 10) {
                    param.cat1_id = _this3.fileUploadModel.cat1_id;
                }
                if (_this3.resourceType === 18) {
                    param.cat1_id = item.animationCat[0];
                    param.cat2_id = item.animationCat[1];
                    param.img_file = item.animationCover;
                }
                Object.keys(requestField).forEach(function(key) {
                    var value = item[requestField[key]];
                    if (value !== undefined) {
                        param[key] = value;
                    }
                });
                return cookRequestParams(param);
            });
            _this.$emit("submit", {
                params: params,
                fileList: _this.fileList
            });
        });
    };
    _createClass(PatchDialog, [
        {
            key: "isVideoManager",
            get: // computed
            function get() {
                return this.uploaderType === "vedioManager";
            }
        },
        {
            key: "isCreative",
            get: function get() {
                return this.uploaderType === "creative";
            }
        },
        {
            key: "dialogWidth",
            get: function get() {
                if (this.isVideoManager) {
                    if (this.resourceType === 13) {
                        return "800px";
                    }
                    return "1000px";
                }
                if (this.isCreative) {
                    switch(this.resourceType){
                        case 16:
                        case 14:
                        case 6:
                        case 15:
                            return "1000px";
                        default:
                            return "800px";
                    }
                }
                switch(this.resourceType){
                    case 16:
                        return "700px";
                    case 14:
                        return "1000px";
                    case 6:
                    case 15:
                        return "1000px";
                    default:
                        return "880px";
                }
            }
        },
        {
            key: "cancelLabel",
            get: function get() {
                return this.dialogConfig.cancelLabel || "\u53D6 \u6D88";
            }
        },
        {
            key: "confirmLabel",
            get: function get() {
                return this.dialogConfig.confirmLabel || "\u63D0 \u4EA4";
            }
        },
        {
            key: "libName",
            get: function get() {
                var _this = this;
                return (repositoryName.find(function(e) {
                    return e.value === Number(_this.resourceType);
                }) || {}).label;
            }
        },
        {
            key: "accessProps",
            get: function get() {
                var allProps = [
                    "name",
                    "name_en",
                    "resFile",
                    "filePath",
                    "tagIds",
                    "accessAllowPt",
                    "nine",
                    "$action"
                ];
                if (this.isCreative) {
                    allProps = allProps.filter(function(item) {
                        return item !== "accessAllowPt";
                    });
                }
                if (this.isVideoManager) {
                    return allProps.filter(function(item) {
                        return [
                            "accessAllowPt",
                            "nine"
                        ].indexOf(item) === -1;
                    });
                }
                if (this.resourceType === 16) {
                    return allProps.filter(function(item) {
                        return [
                            "tagIds",
                            "nine"
                        ].indexOf(item) === -1;
                    });
                }
                if (this.resourceType === 18) {
                    var temp = allProps.filter(function(item) {
                        return [
                            "resFile",
                            "tagIds",
                            "nine",
                            "$action"
                        ].indexOf(item) === -1;
                    });
                    temp.push("resFile", "animationCat", "animationCover", "$action");
                    return temp;
                }
                if (this.resourceType === 14) {
                    return _toConsumableArray(allProps);
                }
                return allProps.filter(function(item) {
                    return item !== "nine";
                });
            }
        },
        {
            key: "propsPool",
            get: function get() {
                var pool = {
                    name: {
                        value: "name",
                        label: "".concat(this.libName, "\u540D\u79F0"),
                        layout: {
                            fields: [
                                "name"
                            ],
                            colAttrs: {
                                span: 5
                            }
                        }
                    },
                    name_en: {
                        value: "name_en",
                        label: "".concat(this.libName, "\u82F1\u6587\u540D\u79F0"),
                        layout: {
                            fields: [
                                "name_en"
                            ],
                            colAttrs: {
                                span: 5
                            }
                        }
                    },
                    resFile: {
                        value: "resFile",
                        label: "".concat(this.libName, "\u56FE\u6807"),
                        layout: {
                            fields: [
                                "resFile"
                            ],
                            colAttrs: {
                                span: 5
                            }
                        }
                    },
                    tagIds: {
                        value: "tagIds",
                        label: "".concat(this.libName, "\u6807\u7B7E"),
                        layout: {
                            fields: [
                                "tagIds"
                            ],
                            colAttrs: {
                                span: 8
                            }
                        }
                    },
                    accessAllowPt: {
                        value: "accessAllowPt",
                        label: "\u662F\u5426\u5BF9\u5916\u5C55\u793A",
                        layout: {
                            fields: [
                                "accessAllowPt"
                            ],
                            colAttrs: {
                                span: 4
                            }
                        }
                    },
                    animationCat: {
                        value: "animationCat",
                        label: "\u52A8\u753B\u5206\u7C7B",
                        layout: {
                            fields: [
                                "animationCat"
                            ],
                            colAttrs: {
                                span: 4
                            }
                        }
                    },
                    animationCover: {
                        value: "animationCover",
                        label: "\u52A8\u753B\u56FE\u6807",
                        layout: {
                            fields: [
                                "animationCover"
                            ]
                        }
                    },
                    nine: {
                        value: "nine",
                        label: "\u70B9\u4E5D\u56FE",
                        layout: {
                            fields: [
                                "nine"
                            ],
                            colAttrs: {
                                span: 4
                            }
                        }
                    },
                    $action: {
                        value: "$action",
                        label: "\u64CD\u4F5C",
                        layout: {
                            fields: [
                                "$action"
                            ],
                            colAttrs: {
                                span: 2
                            }
                        }
                    }
                };
                return pool;
            }
        },
        {
            key: "tableFormHead",
            get: function get() {
                var _this = this;
                var heads = this.accessProps.map(function(prop) {
                    return _this.propsPool[prop];
                }).filter(Boolean).map(function(item) {
                    return {
                        value: item.value,
                        label: item.label,
                        span: _this.getColSpan(item.value)
                    };
                });
                return heads;
            }
        },
        {
            key: "fileUploadConfig",
            get: function get() {
                var acceptType = [];
                var tip = "";
                switch(Number(this.resourceType)){
                    case 5:
                        acceptType = [
                            "mp4"
                        ];
                        tip = "\u4EC5\u652F\u6301\u4E0A\u4F20MP4\u683C\u5F0F\u7684\u6587\u4EF6\uFF0C\u6587\u4EF6\u6700\u5927\u4E0D\u80FD\u8D85\u8FC71.5G";
                        break;
                    case 6:
                    case 15:
                        acceptType = [
                            "mp3"
                        ];
                        tip = "\u652F\u6301\u4E0A\u4F20MP3\u683C\u5F0F\u7684\u6587\u4EF6";
                        break;
                    case 10:
                        // 特效
                        acceptType = [
                            "zip"
                        ];
                        if (this.fileUploadModel.cat1_id === 1) {
                            tip = "\u4EC5\u652F\u6301zip\u683C\u5F0F\uFF0Czip\u5305\u5185\u5BB9\u5FC5\u987B\u7B26\u5408\u9F99\u9AA8\u6587\u4EF6\u89C4\u8303\uFF08\u4E00\u4E2A\u56FE\u7247+2\u4E2Ajson\u6587\u4EF6\uFF09";
                        } else if (this.fileUploadModel.cat1_id === 2) {
                            tip = "\u4EC5\u652F\u6301zip\u683C\u5F0F\uFF0Czip\u5305\u4E2D\u53EA\u80FD\u4E3A\u56FE\u7247\u5185\u5BB9\uFF08png\uFF09";
                        } else if (this.fileUploadModel.cat1_id === 3) {
                            acceptType = [
                                "zip",
                                "unitypackage"
                            ];
                            tip = "\u4EC5\u652F\u6301zip/unitypackage\u683C\u5F0F\uFF0C\u82E5\u4E3Azip\u5305\uFF0C\u5219zip\u5305\u4E2D\u53EA\u80FD\u6709\u4E09\u4E2A\u6587\u4EF6\u5206\u522B\u4EE5\uFF08.bin,.meta,.prefab\uFF09\u7ED3\u5C3E";
                        }
                        break;
                    case 18:
                    case 16:
                        acceptType = [
                            "zip"
                        ];
                        tip = "\u4EC5\u652F\u6301zip\u683C\u5F0F\uFF0C\u4E14zip\u5305\u4E2D\u5FC5\u987B\u5305\u542B\u4E09\u4E2A\u5206\u522B\u4EE5(.bin,.meta,.prefab)\u7ED3\u5C3E\u7684\u6587\u4EF6";
                        break;
                    default:
                        acceptType = [
                            "jpg",
                            "png",
                            "jpeg"
                        ];
                        tip = "\u4EC5\u652F\u6301jpg, png, jpeg\u683C\u5F0F\u56FE\u7247";
                        break;
                }
                return {
                    acceptType: acceptType,
                    tip: tip
                };
            }
        },
        {
            key: "fileUploadSchema",
            get: function get() {
                var _this = this;
                if (!this.resourceType || !this.dialogConfig.visible) {
                    return {
                        type: "object",
                        properties: {}
                    };
                }
                var cat1Visible = this.resourceType === 10;
                return {
                    type: "object",
                    properties: {
                        cat1_id: {
                            visible: cat1Visible,
                            title: "".concat(this.libName, "\u5B9E\u73B0\u65B9\u5F0F\uFF1A"),
                            component: "radio-group",
                            rules: [
                                {
                                    required: true,
                                    message: "\u8BF7\u9009\u62E9" + this.libName + "\u5B9E\u73B0\u65B9\u5F0F"
                                }
                            ],
                            field: {
                                options: _toConsumableArray(cat1OptionsParticle),
                                listeners: {
                                    change: function() {
                                        _this.tableFormModel = [];
                                        _this.tableFormSchema = [];
                                        _this.fileList = [];
                                        _this.fileUploadFileList = [];
                                    }
                                }
                            }
                        },
                        file_path: {
                            component: FileUploader,
                            field: _objectSpread({
                                multiple: true,
                                drag: true,
                                fileList: this.fileUploadFileList
                            }, this.fileUploadConfig),
                            handleUploadSuccess: this.handleUploadSuccess,
                            beforeUpload: this.handleBeforeUpload
                        }
                    }
                };
            }
        },
        {
            key: "tableFormLayout",
            get: // TODO any
            function get() {
                var _this = this;
                var defaultColAttrs = {
                    class: "el-table__cell",
                    tag: "td"
                };
                var col = this.accessProps.map(function(prop) {
                    return _this.propsPool[prop];
                }).filter(Boolean).map(function(item) {
                    var layout = item.layout;
                    var fields = layout.fields;
                    var colAttrs = _objectSpread({}, defaultColAttrs, layout.colAttrs || {});
                    colAttrs.span = _this.getColSpan(item.value);
                    return {
                        colAttrs: colAttrs,
                        fields: fields
                    };
                });
                return [
                    {
                        rowAttrs: {
                            type: "flex",
                            justify: "start",
                            align: "center",
                            tag: "tr"
                        },
                        col: col
                    }
                ];
            }
        },
        {
            key: "applyAllIndex",
            get: function get() {
                return this.tableFormModel.findIndex(function(item) {
                    return item.applyAll;
                });
            }
        },
        {
            key: "animationCat",
            get: function get() {
                return animationType.map(function(item) {
                    var key = "stress";
                    if (item.value === 1) {
                        key = "approach";
                    }
                    if (item.value === 2) {
                        key = "exit";
                    }
                    return _objectSpreadProps(_objectSpread({}, item), {
                        children: animationTag[key]
                    });
                });
            }
        }
    ]);
    return PatchDialog;
}(Vue);
__decorate([
    Prop({
        default: "material"
    })
], PatchDialog.prototype, "uploaderType", void 0);
__decorate([
    Prop({
        default: 0
    })
], PatchDialog.prototype, "resourceType", void 0);
__decorate([
    Prop({
        default: function() {
            return defaultDialogConfig;
        }
    })
], PatchDialog.prototype, "dialogConfig", void 0);
__decorate([
    Watch("dialogConfig.visible")
], PatchDialog.prototype, "onDialogConfigVisibleChange", null);
PatchDialog = __decorate([
    Component({
        components: {
            FileUpload: FileUpload,
            TableForm: TableForm,
            SingleImageUploader: SingleImageUploader
        }
    })
], PatchDialog);
export { PatchDialog as default };
